import { CouponCard, CouponModel, useCouponHistoryQuery } from '@entities/coupon'
import { useTranslation } from '@shared/config/i18n'

import { Flex, Typography } from '@podo-app/design-system-temp'
import { PodoEmpty2Icon } from '@podo/assets'

const CouponHistory = () => {
  const { data: couponHistories } = useCouponHistoryQuery()
  const histories = Array.isArray(couponHistories) ? couponHistories : []

  if (histories.length === 0) {
    return <EmptyCouponHistory />
  }

  return (
    <Flex direction="vertical" className="items-center gap-2" data-testid="list-coupon-history">
      {histories.map((coupon) => {
        const couponModel = CouponModel.create(coupon)

        if (couponModel.isAvailable) {
          return null
        }

        return (
          <CouponCard
            status={
              couponModel.plain.displayStatus as Extract<typeof couponModel.plain.displayStatus, 'USED' | 'EXPIRED'>
            }
            isPercentageDiscount={couponModel.isPercentageDiscount}
            key={coupon.couponId}
            title={couponModel.plain.title}
            id={coupon.couponId}
            discountType={couponModel.plain.discountType}
            discountAmount={couponModel.plain.discountAmount}
            discountAmountMax={couponModel.plain.discountAmountMax}
            isMaximumDiscount={couponModel.isMaximumDiscount}
            isSubscribePayment={couponModel.isSubscribePayment}
            useStartedAt={couponModel.couponDisplayStartedAt}
            useEndedAt={couponModel.plain.utcUseEnd}
            usedAt={couponModel.plain.utcDisplayUsedAt}
          />
        )
      })}
    </Flex>
  )
}

export default CouponHistory

const EmptyCouponHistory = () => {
  const t = useTranslation()

  return (
    <Flex direction="vertical" className="items-center" data-testid="empty-coupon-history">
      <Flex direction="vertical" className="items-center gap-12 mt-20 mb-12">
        <PodoEmpty2Icon />
        <Typography size="body1" className="text-gray-400 text-center">
          {t('coupon.empty.history')}
        </Typography>
      </Flex>
    </Flex>
  )
}
